import IconSvg from './assets/icons/32/success.svg';
import { FC } from 'react';
const Icon: FC = () => <img alt="success" src={IconSvg} width="32px" height="32px" />;

export default Icon;
